/* eslint-disable */
// CRA is deprecated, doesn't support legacy browser and polyfills doesn't work as expected.
// This custom polyfills is a temporary solution to support legacy browsers features that generate crash on our users browsers.

(function () {
  if (!Array.prototype.at) {
    console.log('Custom Polyfilling Array.prototype.at');
    Object.defineProperty(Array.prototype, 'at', {
      value: function at<T>(this: T[], index: number): T | undefined {
        const len = this.length >>> 0;
        let n = Math.trunc(Number(index)) || 0;
        if (n < 0) n += len;
        if (n < 0 || n >= len) return undefined;
        return this[n];
      },
      writable: true,
      enumerable: false,
      configurable: true,
    });
  }

  if (!Object.hasOwn) {
    console.log('Custom Polyfilling Object.hasOwn');
    Object.defineProperty(Object, 'hasOwn', {
      value: function hasOwn<T extends object>(
        obj: T,
        prop: PropertyKey
      ): boolean {
        if (obj == null) throw new TypeError('Cannot convert undefined or null to object');
        return Object.prototype.hasOwnProperty.call(obj, prop);
      },
      writable: true,
      enumerable: false,
      configurable: true,
    });
  }
})();


